import React from 'react';
import ManualMedicalCheckModal from './ManualMedicalCheckModal';
import ScheduleMedicalCheckModal from './ScheduleMedicalCheckModal';
import { LeadDetailsResponse } from '../../types';

// HWM-22859: single entry point for medical-check scheduling. Picks the
// provider-appropriate modal so callers don't each duplicate the branch:
//   - DrChrono orgs  → slot-picker `ScheduleMedicalCheckModal`
//   - everyone else  → manual date/time + note `ManualMedicalCheckModal`
// Callers just control open/close + reschedule mode and render this once.
interface MedicalCheckSchedulingModalProps {
    lead?: LeadDetailsResponse;
    leadId: string;
    isReschedule?: boolean;
    onClose: () => void;
    // Fires after a successful manual schedule. The DrChrono modal refreshes
    // itself via query invalidation, so this is only wired to the manual path.
    onSuccess?: () => void;
}

const MedicalCheckSchedulingModal: React.FC<MedicalCheckSchedulingModalProps> = ({
    lead,
    leadId,
    isReschedule = false,
    onClose,
    onSuccess
}) => {
    if (lead?.scheduling_provider === 'drchrono') {
        return (
            <ScheduleMedicalCheckModal
                leadId={leadId}
                isReschedule={isReschedule}
                onClose={onClose}
            />
        );
    }

    const patientName = `${lead?.primary_user_details.first_name ?? ''} ${
        lead?.primary_user_details.last_name ?? ''
    }`.trim();

    return (
        <ManualMedicalCheckModal
            leadId={leadId}
            patientName={patientName || undefined}
            isReschedule={isReschedule}
            onClose={onClose}
            onSuccess={onSuccess}
        />
    );
};

export default MedicalCheckSchedulingModal;
